import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, fileUrl, FALLBACK_ARTIST } from "@/lib/api";
import { EmptyState, PageTitle } from "@/components/site/ReleaseCard";

export default function Artists() {
  const [artists, setArtists] = useState([]);
  useEffect(() => { api.get("/artists").then((r) => setArtists(r.data)).catch(() => {}); }, []);
  return (
    <div data-testid="artists-page">
      <PageTitle over="Roster" title="Artisti" sub="Le menti e i groove dietro The Groove Anomaly records." />
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        {artists.length ? (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {artists.map((a, i) => (
              <Link key={a.id} to={`/artisti/${a.id}`} data-testid={`artist-card-${a.id}`} className="group relative aspect-[4/5] overflow-hidden border border-white/10 rise hover:border-emerald-500/50 transition-colors" style={{ animationDelay: `${i * 80}ms` }}>
                <img src={fileUrl(a.photo_url) || FALLBACK_ARTIST} alt={a.name} className="absolute inset-0 h-full w-full object-cover grayscale group-hover:grayscale-0 group-hover:scale-105 transition-[filter,transform] duration-700" />
                <div className="absolute inset-0 bg-gradient-to-t from-black via-black/30 to-transparent" />
                <div className="absolute bottom-0 p-6">
                  <p className="font-mono-tga text-[10px] uppercase tracking-[0.25em] text-emerald-400">{[a.genre, a.city].filter(Boolean).join(" · ")}</p>
                  <h3 className="font-display text-2xl font-black uppercase tracking-tight mt-2">{a.name}</h3>
                </div>
              </Link>
            ))}
          </div>
        ) : (
          <EmptyState testid="artists-empty" title="Roster in costruzione" text="Presto gli artisti dell'etichetta." />
        )}
      </div>
    </div>
  );
}
